import * as React from 'react';
import { NavigationMobileMenu } from './navigation-mobile';
import { SideNav } from './side-nav';
interface NavigationWrapperProps {
  children?: React.ReactNode;
}
export const NavigationWrapper = ({
  children
}: NavigationWrapperProps) => {
  const [mobileLayout, setMobileLayout] = React.useState(false);
  React.useEffect(() => {
    // Match --md
    const mediaQueryList = window.matchMedia('(min-width: 1024px)');
    const handleChange = () => setMobileLayout(!mediaQueryList.matches);
    handleChange();
    mediaQueryList.addEventListener('change', handleChange);
    return () => mediaQueryList.removeEventListener('change', handleChange);
  }, []);
  return <>
      {mobileLayout ? <NavigationMobileMenu>{children}</NavigationMobileMenu> : children && <SideNav>{children}</SideNav>}
    </>;
};